import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import '../designcss/blogscss.css';

const BlogTemplate = () => {
    const [blogs, setBlogs] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMoreBlogs, setHasMoreBlogs] = useState(true); // Flag to track if there are more blogs

    const observer = useRef();

    // 1. Huwag kalimutan itong function para gumana yung Copy Link button
    const copyToClipboard = (id) => {
        const shareLink = `${window.location.origin}/view-blog/${id}`;
        navigator.clipboard.writeText(shareLink);
        alert("Link copied! Share it now: " + shareLink);
    };

    useEffect(() => {
        const fetchBlogs = async () => {
            // Stop kung loading na o wala nang blogs
            if (loading || !hasMoreBlogs) return; 

            setLoading(true);
            try {
                const response = await fetch(`https://albiemer.onrender.com/api/getblogs?page=${page}`);
                const data = await response.json();

                if (data.length === 0) {
                    setHasMoreBlogs(false);
                    return; // Exit agad
                }

                setBlogs((prevBlogs) => {
                    // Duplicate checking is good insurance!
                    const newBlogs = data.filter(
                        (newBlog) => !prevBlogs.some((existingBlog) => existingBlog.id === newBlog.id)
                    );
                    return [...prevBlogs, ...newBlogs];
                });

            } catch (error) {
                console.error("Error fetching blogs:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
        // 'page' lang ang dependency dito
    }, [page]);

    const lastPostElementRef = useCallback((node) => {
        if (loading || !hasMoreBlogs) return; // Stop observing if no more blogs or if loading

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasMoreBlogs) {
                setPage((prevPage) => prevPage + 1); // Load next page when the last post is in view
            }
        });

        if (node) observer.current.observe(node); // Observe the last post
    }, [loading, hasMoreBlogs]);

    return (
        <>
            {/* Isang blogcontainer lang para sa lahat ng posts */}
            <div className="blogcontainer">
                {blogs.map((blog, index) => (
                    <div
                        className="card" /* Dito lang ang card style */
                        key={blog.id}
                        ref={blogs.length === index + 1 ? lastPostElementRef : null}
                    >
                        <h2>{blog.title}</h2>
                        <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                            <img src={blog.image} alt={blog.title} loading="lazy" />
                        </div>
                        [{blog.date}] - <b>{blog.author}</b>
                        <p style={{ whiteSpace: "pre-wrap", marginTop: "15px"}}>{blog.content}</p>
                    
                        <div style={{ 
                        display: "flex", 
                        gap: "10px", 
                        padding: "0 15px" // Pantay sa gilid ng card
                    }}>
                        <Link to={`/view-blog/${blog.id}`} style={{ flex: 1, textDecoration: "none" }}>
                            <button style={{
                                width: "100%",
                                padding: "10px",
                                background: "#000",
                                color: "cyan",
                                border: "none",
                                borderRadius: "5px",
                                fontWeight: "bold",
                                cursor: "pointer"
                            }}>
                                Open Link
                            </button>
                        </Link>

                        <button 
                            onClick={() => copyToClipboard(blog.id)}
                            style={{
                                flex: 1,
                                padding: "10px",
                                background: "rgba(0, 0, 0, 0.1)",
                                color: "cyan",
                                border: "1px solid cyan",
                                borderRadius: "5px",
                                fontWeight: "bold",
                                cursor: "pointer"
                            }}
                        >
                            🔗 Copy Link
                        </button>
                    </div>

                    </div>
                ))}

                {/* Status Messages - Nakadikit sa loob ng container pero hiwalay sa card */}
                {loading && hasMoreBlogs && (
                    <div style={{ padding: '20px', textAlign: 'center', width: '100%' }}>
                        <p>Loading more posts...</p>
                    </div>
                )}
                
                {!hasMoreBlogs && blogs.length > 0 && (
                    <div style={{ padding: '20px', textAlign: 'center', width: '100%' }}>
                        <p>You've reached the end of the logs.</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default BlogTemplate;